<template>
  <div class="row row-eq-height no-gutters">
    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 height">
      <aside id="sidebar">
        <div class="heading-holder">
          <h2>Experiment Details</h2>
        </div>
        <ul class="main-list">
          <li>
            <div class="img-txt">
              <img src="../../assets/Lowercase-Outline1.png">
              <h3>Classes</h3>
            </div>
            <ul class="noselection">
              <li v-for="(classData, index) in classes" :key="classData.id">
                <div class="bg-class" :class="'bg-class-' + index % 5"></div><p>{{classData.displayName}}</p>
              </li>
            </ul>
            <button data-toggle="modal" data-target="#classes_for_analysis_popup" type="button" class="bg-blue button raised  hoverable"><div class="anim"></div>Edit</button>
          </li>
          <class-analysis-popup></class-analysis-popup>
          <li>
            <div class="img-txt">
              <img src="../../assets/Microscope-Outline1.png">
              <h3>Text for Classification</h3>
            </div>
            <ul class="nocolor">
              <li>
                <p v-if="testText && testText.displayName">{{testText.displayName}}</p>
                <p v-else>No Selection</p>
              </li>
            </ul>
            <button data-toggle="modal" data-target="#text_for_classification_popup" type="button" class="bg-blue button hoverable"><div class="anim"></div>Edit</button>
          </li>
          <text-classify-popup></text-classify-popup>
        </ul>
      </aside>
    </div>
    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12 height1">
      <div id="contant">
        <ul class="nav nav-tabs analysis">
          <li :class="{active: this.activeTabs['class_tab']}" @click="activateTab('class_tab')"><a href="#"><h2>Analysis of Classes</h2></a></li>
          <li :class="{active: this.activeTabs['text_tab']}" @click="activateTab('text_tab')" ><a href="#"><h2>Text Classification</h2></a></li>
          <div class="i-doc blue float-left"><i class="fas fa-info-circle fa-lg" @click="openHelpTab"></i></div>
       </ul>

        <div class="tab-content1 tab-content2">
          <div v-bind:style="{'display': activeTabs.class_tab ? 'block' : 'none'}" id="ClassesAnalysis">
            <div v-if="(cvState === RunStates.RUNNING) || (extractFeaturesState === RunStates.RUNNING) || (updateFeaturesState === RunStates.RUNNING)">
              <spinner></spinner>
            </div>
            <div v-else-if="cvState === RunStates.NOT_RUN || extractFeaturesState === RunStates.NOT_RUN">
              When you run an analysis of multiple classes, the results will appear here.
            </div>
            <div v-else>
              <div id="cv_timed_out" v-if="cvState === RunStates.TIMED_OUT" class="no-txt">
                <h3>Cross-validation: Server took too long to respond.</h3>
                <button type="button" @click="hideElement('#cv_timed_out')" class="button hoverable pull-right"><div class="anim"></div><img src="../../assets/ic_cancel_small.png"> Close</button>
              </div>
              <div id="cv_failed" v-if="cvState === RunStates.FAILED" class="no-txt">
                <h3>Cross-validation: Server failed to respond.</h3>
                <button type="button" @click="hideElement('#cv_failed')" class="button hoverable pull-right"><div class="anim"></div><img src="../../assets/ic_cancel_small.png"> Close</button>
              </div>
              <div class="row" v-if="cvState === RunStates.COMPLETE">
                <div class="col-xs-12">
                  <div class="maintxt">
                    <h1 class="heading-title">Expected Accuracy: {{cv}}</h1>
                    <div v-if="showTooFewVersesError" class="too-few-verses">
                      <p>You have selected fewer than 200 verses{{ tooFewVersesErrorText }}.<br >To maximize the program's ability to classify new texts, each text class should contain a minimum of 200 verses.</p>
                    </div>
                    <p><a style="margin-left: 0" data-toggle="modal" data-target="#mypopup-classification"
                                                 class="link f gray" href="#">View Outliers</a></p>
                    <outliers-popup></outliers-popup>
                  </div>
                </div>
              </div>
              <div class="new-list">
                <div v-if="(extractFeaturesState === RunStates.COMPLETE) || (cvState === RunStates.COMPLETE)" class="heading-area">
                  <div class="row">
                    <div class="col-xs-6">
                      <h2>Top Features of Each Class</h2>
                    </div>
                    <div class="col-xs-6" v-if="extractFeaturesState === RunStates.COMPLETE">
                      <a @click="editTimesOpened++" data-toggle="modal" data-target="#remove_words_features_popup" href="#"
                         class="custom-link pull-right f gray">View / Edit Features</a>
                      <edit-features-popup v-bind:timesopened="editTimesOpened"></edit-features-popup>
                    </div>
                  </div>
                </div>
                <div v-if="extractFeaturesState === RunStates.TIMED_OUT" id="ef_timed_out" class="no-txt">
                  <h3>Feature Extraction: Server took too long to respond.</h3>
                  <button type="button" @click="hideElement('#ef_timed_out')" class="button hoverable pull-right"><div class="anim"></div><img src="../../assets/ic_cancel_small.png"> Close</button>
                </div>
                <div v-if="extractFeaturesState === RunStates.FAILED" id="ef_failed" class="no-txt">
                  <h3>Feature Extraction: Server failed to respond.</h3>
                  <button type="button" @click="hideElement('#ef_failed')" class="button hoverable pull-right"><div class="anim"></div><img src="../../assets/ic_cancel_small.png"> Close</button>
                </div>
                <verses-popup v-bind:feature="chosenFeature"></verses-popup>
                <div v-for="(classData, index) in classes" :key='classData.id'
                     v-if="extractFeaturesState === RunStates.COMPLETE">
                  <p><span class="bg-class" :class="'bg-class-' + index % 5"></span> {{classData.displayName}}</p>
                  <ul>
                    <li v-for="(feature, featureIndex) in bestFeatures['class' + index]" :key="featureIndex"
                        v-if="featureIndex < 3 || (featureIndex < 5 && feature.tTest > 2)">
                      <a v-on:click="focus(feature)" data-toggle="modal" data-target="#verses-popup"
                         class="f gray" href="#">
                        {{prettyPrint(feature.featureName)}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div v-bind:style="{'display': activeTabs.text_tab ? 'block' : 'none'}" id="TextClassification">
            <text-classification-tab></text-classification-tab>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import $ from 'jquery'
import OutliersPopup from './outliersPopup.vue'
import EditFeaturesPopup from './editFeaturesPopup.vue'
import ClassAnalysisPopup from './classAnalysisPopup.vue'
import TextClassifyPopup from './textClassificationPopup.vue'
import VersesPopup from './versesPopup.vue'
import textMixins from '../../mixins/textMixins'
import textClassificationTab from './textClassificationTab.vue'
import Spinner from '../spinner'
import routeGlobals from '../../mixins/routeGlobals'
import {versesInKey} from '../../mixins/book_to_chapter_and_verse_counts'

export default {
  name: 'result',
  components: {
    Spinner,
    VersesPopup,
    TextClassifyPopup,
    ClassAnalysisPopup,
    EditFeaturesPopup,
    OutliersPopup,
    textClassificationTab
  },
  mixins: [textMixins, routeGlobals],
  data () {
    return {
      activeTabs: {'text_tab': false, 'class_tab': true},
      chosenFeature: 'not yet',
      showTooFewVersesError: false,
      tooFewVersesErrorText: '',
      editTimesOpened: 0
    }
  },
  computed: {
    classifyState: function () {
      return this.$store.state.classifyState
    }
  },
  watch: {
    updateFeaturesState: function (newUpdateFeaturesState) {
      // console.log('newUpdateFeaturesState:')
      // console.log(newUpdateFeaturesState)
      if (newUpdateFeaturesState === this.RunStates.COMPLETE) {
        this.analyze()
      }
    },
    classifyState: function (classifyState) {
      if (classifyState === this.RunStates.RUNNING) {
        this.activateTab('text_tab')
        // $('#TextClassification').addClass('active').addClass('show')
        // $('#ClassesAnalysis').removeClass('active').removeClass('show')
      }
    },
    cvState (cvState) {
      if (cvState === this.RunStates.COMPLETE) this.checkIfTooFewVerses()
    }
  },
  methods: {
    checkIfTooFewVerses () { // copied from classAnalysisPopup.vue
      // verse counts don't have to be accurate, they just need to detect if the text is too short
      // DL - but for now, they are accurate
      const verseCounts = this.classes.map(classData => {
        let verseCount = 0
        for (const key of classData.keys) {
          if (/Pasuk \d*$/.test(key)) {
            verseCount += 1
          } else {
            verseCount += versesInKey(key)
          }
        }
        return verseCount
      })
      console.log('verseCounts:')
      console.log(verseCounts)
      if (verseCounts.some(count => count < 200)) {
        this.showTooFewVersesError = true
        let tooSmallClasses = this.classes.filter((classData, index) => { return verseCounts[index] < 200 })
        console.log('tooSmallClasses:')
        console.log(tooSmallClasses)
        this.tooFewVersesErrorText = ' in ' + tooSmallClasses.map(classData => {
          return classData.name ? classData.name : 'Class ' + (this.classes.map(classData => classData.id).indexOf(classData.id) + 1)
        }).join(', ')
        if (tooSmallClasses.length > 1) this.tooFewVersesErrorText = this.tooFewVersesErrorText.replace(/,([^,]*)$/, ' and $1')
        return
      }
      this.showTooFewVersesError = false
    },
    openHelpTab () { // directories defined in routeGlobals
      if (this.activeTabs.class_tab) {
        window.open(this.helpRootDir + this.helpPagesSubDir + 'analysis-of-classes.htm')
      } else window.open(this.helpRootDir + this.helpPagesSubDir + 'text-classification.htm')
    },
    hideElement: function (idString) {
      $(idString).hide()
    },
    activateTab: function (tab) {
      for (var Tab in this.activeTabs) {
        this.activeTabs[Tab] = false
      }
      this.activeTabs[tab] = true
      if (tab === 'text_tab') {
        // console.log('Preparing to fire "scroll" event to trigger graph')
        /* setTimeout(() => {
          // console.log('Trying to actually fire "scroll" event to trigger graph')
          window.scrollTo(window.scrollX, window.scrollY + 1)
        }, 500) */
      }
    },
    focus (oneFeature) {
      this.chosenFeature = {
        featureName: oneFeature.featureName,
        featureType: oneFeature.featureType
      }
      console.log('this.chosenFeature:')
      console.log(this.chosenFeature)
    }
  },
  mounted: function () {
    // (should no longer be needed - initial state fixed) this.activateTab('class_tab')
  }
}
</script>
<style scoped>
  .no-txt {
    width: 451px;
    overflow: hidden;
    position: relative;
    border-radius: 2px;
    padding: 21px 21px 9px;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.37);
    background-color: #ffffff;
    border: solid 1px #c0c0c0;
  }
  .no-txt:before{
    width: 2px;
    height: 100%;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background: #ff0000;
  }
  .no-txt .button{
    min-width: 79px;
    height: 28px;
    color: #000;
    box-shadow: none;
    line-height: 28px;
    border-radius: 2px;
    margin: 0 -11px 0 0;
    background-color: #e0e0e0;
  }
  .no-txt .button img{
    display: inline-block;
    vertical-align: middle;
    margin: -1px 0 0 0;
  }
  .too-few-verses {
    border-radius: 3px;
    border: 1px solid rgb(205, 205, 205);
    padding: 11px;
    margin: 10px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/experiment/result.vue